import React, { Component } from 'react'
import classNames from 'classnames'

class Field extends Component {

	constructor(props) {
		super(props);

		this.state = {
			isFocus: false,
		}

		this.handleFocus = this.handleFocus.bind(this)
		this.handleBlur = this.handleBlur.bind(this)
		this.handleLabelClick = this.handleLabelClick.bind(this)
		this.handleChange = this.handleChange.bind(this)
	}

	render() {

		const { placeholder, label , value, ...rest } = this.props
		const { isFocus } = this.state

		const isActive = isFocus || placeholder || value

		let labelTag = null
		if(label) {
			const labelClass = classNames(
				'field__label',
				{
					'field__label--active': isActive,
					'field__label--focus': isFocus,
				}
			)
			labelTag = <label className={labelClass} onClick={this.handleLabelClick}>{label}</label>
		}

		const fieldClass = classNames(
			'field',
			{
				'field--with-label': label,
			}
		)

		const barClass = classNames(
			'field__bar',
			{'field__bar--focus': isFocus}
		)

		return (
			<div className={fieldClass}>
				{labelTag}
				<input
					className="field__input"
					placeholder={placeholder}
					value={value}
					{...rest}
					onChange={this.handleChange}
					onFocus={this.handleFocus}
					onBlur={this.handleBlur}
					ref={elem => this.input = elem} />
				<div className={barClass}></div>
			</div>
		)
	}

	handleFocus() {
		const { onFocus } = this.props

		this.setState({ isFocus: true })

		onFocus && onFocus()
	}

	handleBlur() {
		const { onBlur } = this.props

		this.setState({ isFocus: false })

		onBlur &&onBlur()
	}

	handleLabelClick() {
		this.input.focus()
	}

	handleChange(event) {
		const { onChange } = this.props
		const { name, value } = event.target

		onChange(value, name)
	}
}

export default Field



// WEBPACK FOOTER //
// ./src/js/Ui/Field/Field.jsx